import { Koi } from '@ksyos/koi';
import { GgzProfession } from '@common/enums';
import { ActivityType } from '@common/enums/activityType';
import type { ISchemaContainer } from './schemaContainer';

export interface ICompensationPayoutEditValidated {
    amount: number;
    endDate: string | null;
    profession?: GgzProfession | null;
    startDate: string;
    type: ActivityType;
}

const compensationPayoutEdit = Koi.object({
    amount: Koi.number(),
    endDate: Koi.koi().endDate().allow(null),
    profession: Koi.koi().enum(GgzProfession).allow(null).optional(),
    startDate: Koi.koi().date(),
    type: Koi.koi().enum(ActivityType),
});

export const compensationPayoutEditSchema: ISchemaContainer<ICompensationPayoutEditValidated> = {
    schema: compensationPayoutEdit.options({ convert: false, presence: 'required' }),
};

export interface ICompensationPayoutAddValidated extends ICompensationPayoutEditValidated {
    serviceConsumerId?: string;
    serviceGroupSettingId?: string;
    serviceOrganizationSettingId?: string;
    serviceProviderId?: string;
    serviceSupervisorId?: string;
}

export const compensationPayoutAddSchema: ISchemaContainer<ICompensationPayoutAddValidated> = {
    schema: compensationPayoutEdit
        .keys({
            serviceConsumerId: Koi.string().uuid().optional(),
            serviceGroupSettingId: Koi.string().uuid().optional(),
            serviceOrganizationSettingId: Koi.string().uuid().optional(),
            serviceProviderId: Koi.string().uuid().optional(),
            serviceSupervisorId: Koi.string().uuid().optional(),
        })
        .options({ convert: false, presence: 'required' }),
};

export function getValidationSchema(id?: string) {
    return id ? compensationPayoutAddSchema : compensationPayoutEditSchema;
}
